import { Expose, Type } from "class-transformer";
import ShopRes from "types/res/shop/ShopRes";
import NotificationType from "types/enum/NotificationType";
import NotificationReadRes from "types/res/notificationRead/NotificationReadRes";

export default class NotificationRes {
  @Expose() readonly notificationId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly title!: string;
  @Expose() readonly content!: string;
  @Expose() readonly type!: NotificationType;
  @Type(() => Date)
  @Expose()
  readonly startDate!: Date | null;
  @Type(() => Date)
  @Expose()
  readonly endDate!: Date | null;
  @Expose()
  readonly isIndefinite!: boolean | null;
  @Type(() => ShopRes)
  @Expose()
  readonly shops!: ShopRes[];
  @Type(() => NotificationReadRes)
  @Expose()
  readonly notificationReads!: NotificationReadRes[];
}
